import React from 'react';
import Card from './Card';

export interface ParameterCardProps {
  title: string;
  value: string | number;
  description?: string;
  unit?: string;
  confidence?: {
    lower: number;
    upper: number;
    level: number;
  };
  standardError?: number | string;
  color?: 'bright-blue' | 'purple' | 'fleet-monitor' | 'dark-blue' | 'green' | 'sky-blue';
  loading?: boolean;
  className?: string;
}

const ParameterCard: React.FC<ParameterCardProps> = ({
  title,
  value,
  description,
  unit,
  confidence,
  standardError,
  color = 'bright-blue',
  loading = false,
  className = '',
}) => {
  return (
    <Card variant="stats" size="sm" hover={false} loading={loading} className={className}>
      <div>
        <div className="text-sm onyx-subtitle text-gray-600 mb-1">{title}</div>

        <div className="text-2xl onyx-bold mb-2" style={{ color: `var(--onyx-${color})` }}>
          {value}
          {unit && <span className="text-sm text-gray-500 ml-1">{unit}</span>}
        </div>

        {description && <div className="text-xs text-gray-500 onyx-body mb-2">{description}</div>}

        {confidence && (
          <div className="text-xs text-gray-600 onyx-body">
            <div className="onyx-subtitle">
              {confidence.level}% CI: [{confidence.lower.toFixed(3)}, {confidence.upper.toFixed(3)}]
            </div>
          </div>
        )}

        {standardError && (
          <div className="text-xs text-gray-500 onyx-body mt-1">
            {typeof standardError === 'number' ? `SE: ${standardError.toFixed(4)}` : standardError}
          </div>
        )}
      </div>
    </Card>
  );
};

export default ParameterCard;
